import { UserSettingsAcknowledgement } from '../../models/user/userSettingsAcknowledgement.ts';
import { httpFetchJson } from './httpClient';

/**
 * Fetches whether the signed-in user has acknowledged the GDPR notice.
 */
const getGdprAcknowledgementAsync =
  async (): Promise<UserSettingsAcknowledgement> => {
    return httpFetchJson<UserSettingsAcknowledgement>(
      '/api/user-settings/gdpr-acknowledgement',
      { method: 'GET', withBackendAuth: true }
    );
  };

/**
 * Persists GDPR acknowledgement for the signed-in user.
 */
const acknowledgeGdprAsync = async (): Promise<UserSettingsAcknowledgement> => {
  return httpFetchJson<UserSettingsAcknowledgement>(
    '/api/user-settings/gdpr-acknowledgement',
    {
      method: 'POST',
      withBackendAuth: true,
    }
  );
};

export const userSettingsApi = {
  getGdprAcknowledgementAsync,
  acknowledgeGdprAsync,
};
